import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteRiskAreaDialog } from "./DeleteRiskAreaDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function DeleteRiskAreaDialogDataMapping(props: IDeleteRiskAreaDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeRiskArea = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();

                if (response.success()) {
                    props.onDeletion();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.riskAreaName } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "riskAreaNotDeleted", values: { name: props.riskAreaName } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<string>(`/risk-areas/${props.riskAreaId}`);
    }

    return {
        removeRiskArea,
        inProgress: removeMutation.isLoading,
    };
}
